declare global {
  interface Window {
    __REMOTE_BASE_ORIGIN__?: string;
  }
}

export function getRemoteEntryUrl(remoteEntryPath: string): string {
  const path = remoteEntryPath.startsWith("/")
    ? remoteEntryPath
    : `/${remoteEntryPath}`;

  if (typeof window === "undefined") {
    return path;
  }

  const configuredOrigin = window.__REMOTE_BASE_ORIGIN__;
  if (configuredOrigin) {
    return `${configuredOrigin.replace(/\/$/, "")}${path}`;
  }

  // Same-origin path. Localhost uses the rspack /dashboardui proxy;
  // deployed portals serve dashboard assets from the current host.
  return path;
}
